/** Open country between the towns: a dizi tune on the move, the zheng galloping under it, light drums. */
import { arp, drone, vary } from '../compose';
import { registerTrack } from '../registry';

const A_DIZI = `@mf 5_ 6_ 1' 2'. 3'_ | 2'_ 1'_ 6_ 1'_ 5- | 6_ 1'_ 2'_ 3'_ 5'. 3'_ | 2'-- 0 ; |
  3'_ 5'_ 3'_ 2'_ 1' 2'_ 1'_ | 6_ 5_ 6_ 1'_ 2'- | 5_ 6_ 5_ 3_ 2_ 3_ 5_ 6_ | 5-~ 0-`;
const A_ZHENG = `@mp 0--- | 0--- | 0--- | 0-- 5_ 6_ | 0--- | 0--- | 0--- | 0- 1'_ 2'_ 5'g`;
const ROOTS_A = `5,, 1, 2, 5,, 6,, 2, 5,, 5,,`;
const GALLOP = [0, 3, 5, 3, 0, 3, 5, 3];

const B_ZHENG = `@mf 6,g 1_ 2_ 3 5 | 3_ 2_ 1_ 2_ 6,\\- | 5, 6,_ 1_ 2 3_ 5_ | 6%--- |
  1'. 6_ 5 3 | 2_ 3_ 5_ 6_ 5/- | 3_ 5_ 2_ 3_ 1 6, | 5,%---`;
const B_DIZI = `@mp 0--- | 0--- | 0--- | 3'--- ; | 0--- | 0--- | 0--- | 2'-- 0 ;`;
const ROOTS_B = `6,, 6,, 5,, 6,, 1, 2, 6,, 5,,`;

const DRUMS_A = `d_ 0_ k_ k_ d_ 0_ k_ 0_`;
const FILL = `D_ 0_ k_ k_ D_ 0_ D_ D_`;

registerTrack({
  id: 'wilds',
  order: 5,
  title: 'ทางไกลใต้ฟ้ากว้าง',
  mood: 'ปลอดโปร่ง ผจญภัย เดินทาง',
  use: 'ทุ่งกว้างและป่านอกเมือง',
  key: 'G',
  mode: 'zhi',
  bpm: 92,
  meter: 4,
  seed: 505,
  parts: {
    dizi: { inst: 'dizi', pan: -0.12, reverb: 0.35 },
    zheng: { inst: 'zheng', gain: 0.9, pan: 0.15 },
    bass: { inst: 'zheng', gain: 0.45, pan: -0.25, reverb: 0.2 },
    pad: { inst: 'pad', gain: 0.6 },
    drums: { inst: 'perc', gain: 0.32, pan: 0.1, reverb: 0.2 },
  },
  sections: {
    A: {
      bars: 8,
      parts: {
        dizi: A_DIZI,
        zheng: A_ZHENG,
        bass: arp(ROOTS_A, GALLOP),
        pad: drone(ROOTS_A, 4),
        drums: [DRUMS_A, DRUMS_A, DRUMS_A, DRUMS_A, DRUMS_A, DRUMS_A, DRUMS_A, FILL].join(' | '),
      },
    },
    B: {
      bars: 8,
      parts: {
        zheng: B_ZHENG,
        dizi: B_DIZI,
        bass: arp(ROOTS_B, [0, null, 3, 5, 0, null, 3, 5]),
        pad: drone(ROOTS_B, 4),
        drums: Array(8).fill(`k_ 0_ k_ 0_ d_ 0_ k_ 0_`).join(' | '),
      },
    },
    A2: {
      bars: 8,
      parts: {
        dizi: vary(A_DIZI, 6, `5_ 3_ 2_ 1_ 6,_ 1_ 2_ 3_`, `5,-~ 0-`),
        zheng: A_ZHENG,
        bass: arp(ROOTS_A, GALLOP),
        pad: drone(ROOTS_A, 4),
        drums: [DRUMS_A, DRUMS_A, DRUMS_A, FILL, DRUMS_A, DRUMS_A, DRUMS_A, FILL].join(' | '),
      },
    },
  },
  form: ['A', 'B', 'A2', 'B', 'A'],
  loop: true,
});
